import { useEffect, useState } from "react";
import { checkReloadStatus, getReloadStatus } from "../utils/reloadTracker";

/**
 * React hook to track page reload status
 * @param {number} checkInterval - Interval in milliseconds to check status (default: 60000 = 1 minute)
 * @returns {Object} { hasNotReloaded: boolean, hoursSinceLastReload: number, status: Object }
 */
export default function useReloadTracker(checkInterval = 60000) {
  const [status, setStatus] = useState(() => checkReloadStatus());

  useEffect(() => {
    // Check immediately
    const updateStatus = () => {
      const currentStatus = checkReloadStatus();
      setStatus(currentStatus);

      // Log warning if approaching 12 hours
      if (currentStatus.hoursSinceLastReload >= 11 && currentStatus.hoursSinceLastReload < 12) {
        console.warn("[ReloadTracker] Approaching 12-hour limit:", {
          hoursSinceLastReload: currentStatus.hoursSinceLastReload,
          lastReloadTime: currentStatus.lastReloadTime,
        });
      }
    };

    updateStatus();

    // Set up interval to check periodically
    const interval = setInterval(updateStatus, checkInterval);

    return () => clearInterval(interval);
  }, [checkInterval]);

  return {
    hasNotReloaded: status.hasNotReloaded,
    hoursSinceLastReload: status.hoursSinceLastReload,
    shouldForceReload: status.shouldForceReload,
    status: getReloadStatus(),
  };
}

